import React from "react";
import { Header } from "../components";
import errorImg from "../data/images/404-not-found.gif";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";

const Error = () => {
  const { isLoggedIn } = useStateContext();
  const navigate = useNavigate();

  return (
    <>
      <section id="header" className="w-screen">
        <Header />
      </section>
      <section id="room-details" className="fixed left-0 right-0 mt-24">
        <div className="flex justify-center text-center text-2xl px-10 my-10">
          Sorry, we couldn't find what you were looking for!
        </div>
        <div className="flex justify-center gap-x-5">
          <div
            className="text-lg text-blue-500 hover:text-blue-700 mt-2 cursor-pointer"
            onClick={() => navigate("/")}
          >
            Home
          </div>
          {isLoggedIn && (
            <div
              className="text-lg text-blue-500 hover:text-blue-700 mt-2 cursor-pointer"
              onClick={() => navigate("/dashboard")}
            >
              Dashboard
            </div>
          )}

          <div
            className="text-lg text-blue-500 hover:text-blue-700 mt-2 cursor-pointer"
            onClick={() => navigate("/rooms")}
          >
            Find A Room
          </div>
        </div>

        <div className="flex justify-center mt-5">
          <img
            id="error-page"
            src={errorImg}
            alt="404 Error - Item can not be round"
            className="w-screen"
          />
        </div>
      </section>
    </>
  );
};

export default Error;
